<template>
  <span class="d-flex">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </span>
</template>
<script>
export default {
  name: 'EmptyNumbers'
}
</script>
